import './no_data_display.scss';
import Image from './../../assets/no_data_display.svg';
import React, { type ReactElement } from 'react';
import { Button } from '../Button/Button';
import { Text } from '../text/text';

interface Props {
  message?: string;
  buttonTitle?: string;
  onButtonClick?: () => void;
}

export function NoDataDisplay({ message, buttonTitle, onButtonClick }: Props): ReactElement {
  return (
    <div className="no-data-display">
      <img src={Image} alt="" />
      <span />
      {message && <Text type="page-text">{message}</Text>}
      {buttonTitle && <Button title={buttonTitle} type="primary" onClick={onButtonClick} />}
    </div>
  );
}
